import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  status: "All",
  colors: [],
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    statusChange: (state, action) => {
      state.status = action.payload;
    },
    colorChange: (state, action) => {
      if (action?.payload?.type === "added") {
        state.colors.push(action?.payload?.color);
      }
      if (action?.payload?.type === "removed") {
        state.colors = state.colors.filter(
          (existingColor) => existingColor !== action?.payload?.color
        );
      }
      if (action?.payload?.type === "") {
        state.colors = [];
      }
    },
  },
});

export default filterSlice.reducer;
export const { colorChange, statusChange } = filterSlice.actions;
